import { Body } from '@depop/web-thrift-ui/Typography';
import clsx from 'clsx';
import { useTranslations } from 'next-intl';

import styles from './styles.module.css';

import { PriceWithMarketplaceFee } from '@/app/[locale]/products/[slug]/components/Price/PriceWithMarketplaceFee';
import { Placeholder, PlaceHolderShape } from '@/components/Placeholder';
import { Price } from '@/components/Price';
import { type CurrencyCode } from '@/modules/currencies/constants';
import { getProductPriceFromPricing } from '@/modules/price/helpers/getProductPriceFromPricing';
import { useProductBySlugExtendedPDP } from '@/modules/product/hooks/useProductBySlugExtendedPDP';

export function MobilePrice() {
  const { data: productExtended, isPending: productExtendedPending } =
    useProductBySlugExtendedPDP();
  const tCommon = useTranslations('common');

  if (productExtendedPending) {
    return (
      <Placeholder
        shape={PlaceHolderShape.RECTANGLE}
        width="110px"
        height="24px"
      />
    );
  }

  if (!productExtended) {
    return null;
  }

  const price = getProductPriceFromPricing(productExtended.pricing);
  const { display_price: displayPrice } = productExtended.pricing;
  const hasTaxInclusivePricing =
    Boolean(price.currentSalesTax) && Number(price.currentSalesTax) > 0;
  const hasMarketplaceFee =
    Boolean(price.currentPriceFees) && !productExtended.is_product_owner;
  const hasSecondaryPrice =
    Boolean(displayPrice.secondary_price) && !productExtended.is_product_owner;

  return (
    <div>
      {hasMarketplaceFee || hasSecondaryPrice ? (
        <PriceWithMarketplaceFee displayPrice={displayPrice} price={price} />
      ) : (
        <>
          <Price
            className={clsx({
              [styles.nonDiscountedPrice]: !displayPrice.strikethrough_price,
            })}
            currencyCode={displayPrice.headline_price.currency as CurrencyCode}
            discountedPrice={
              displayPrice.strikethrough_price
                ? displayPrice.headline_price.amount
                : undefined
            }
            price={
              displayPrice.strikethrough_price?.amount ??
              displayPrice.headline_price.amount
            }
          />
          {hasTaxInclusivePricing && (
            <Body variant="sm-regular" as="span">
              {tCommon('TaxIncluded').toUpperCase()}
            </Body>
          )}
        </>
      )}
    </div>
  );
}
